const INITIAL_STATE = {
    mvm: {},
    sheds: [],
    shed: undefined,
    shedObj: undefined,
    movementType: undefined,
    movementTypeObj: undefined,
    rackTypeList: [],
    confirmationList: [],
    showSupplierComponent: false
};

export default function loadUnloadReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'UPDATE_LOAD_UNLOAD_LIST':
            return {
                ...state,
                result: action.dados,
            };
        case 'INSERT_CONFIRMATION_LIST':
            {
                let list = [];
                Object.assign(list, state.confirmationList);
                const loadItemUpdate = list.find((m) => m.id === action.item.id);

                if (loadItemUpdate) {
                    loadItemUpdate.qtd = action.item.volumeQuantity
                } else {

                    var itemAdd = {
                        id: action.item.id,
                        qtd: action.item.volumeQuantity,
                        fullPackaging: action.item.indFullRack,
                        transportOrder: action.item.requestNumber,
                        shippingCompany: action.item.shippingCompanyId,
                        isPackingFCM: action.item.isPackingFCM,
                        rackType: {
                            id: action.item.rackTypeId,
                            code: action.item.rackTypeCode,
                            description: action.item.rackTypeDescription,
                            ownersupplierId: action.item.rackTypeOwnerSupplierId
                        },
                        supplier: {
                            supplierID: action.item.supplierId,
                            name: action.item.supplierName,
                            supplierUf: action.item.supplierUf,
                            supplierSapCode: action.item.supplierSapCode
                        }
                    }

                    list.push(itemAdd)
                }
                return {
                    ...state,
                    confirmationList: list
                };
            }
        case 'UPDATE_CONFIRMATION_LIST':
            {
                let confirmationList = [];
                Object.assign(confirmationList, state.confirmationList);
                const loadItemUpdate = confirmationList.find((m) => m.id === action.item.id);
                const element = action.item;
                if (loadItemUpdate) {
                    loadItemUpdate.rackType = {
                        id: element.rackTypeId,
                        code: element.rackTypeCode,
                        description: element.rackTypeDescription,
                        ownersupplierId: element.rackTypeOwnerSupplierId
                    };
                    loadItemUpdate.supplier = {
                        supplierID: element.supplierId,
                        name: element.supplierName,
                        supplierUf: element.supplierUf,
                        supplierSapCode: element.supplierSapCode
                    };
                    loadItemUpdate.qtd = element.volumeQuantity;
                    loadItemUpdate.fullPackaging = element.indFullRack;
                    loadItemUpdate.transportOrder = element.requestNumber;
                    loadItemUpdate.shippingCompany = element.shippingCompanyId;
                    loadItemUpdate.isPackingFCM = element.isPackingFCM;
                }

                return {
                    ...state,
                    confirmationList: confirmationList

                };
            }
        case 'REMOVE_CONFIRMATION_LIST':
            let confirmationList = [];
            Object.assign(confirmationList, state.confirmationList);
            confirmationList = confirmationList?.filter((i) => i.id !== action.item);
            return {
                ...state,
                confirmationList: confirmationList
            };
        case 'CLEAR_CONFIRMATION_LIST':
            return {
                ...state,
                confirmationList: INITIAL_STATE.confirmationList,
            };
        case 'SET_MVM': {
            let confirmationList = [];
            if (action.mvm?.load && action.mvm.load.loadItem) {
                action.mvm.load.loadItem.forEach(element => {
                    confirmationList.push({
                        id: element.id,
                        rackType: {
                            id: element.rackTypeId,
                            code: element.rackTypeCode,
                            description: element.rackTypeDescription,
                            ownersupplierId: element.rackTypeOwnerSupplierId
                        },
                        supplier: {
                            supplierID: element.supplierId,
                            name: element.supplierName,
                            supplierUf: element.supplierUf,
                            supplierSapCode: element.supplierSapCode
                        },
                        qtd: element.volumeQuantity,
                        fullPackaging: element.indFullRack,
                        transportOrder: element.requestNumber,
                        shippingCompany: element.shippingCompanyId,
                        isPackingFCM: element.isPackingFCM
                    })
                });
            }
            return {
                ...state,
                mvm: action.mvm,
                confirmationList: confirmationList

            };
        }
        case 'SET_SHED_LIST':
            return {
                ...state,
                sheds: action.list,
            };
        case 'SET_SHED_CONFIG_LIST':
            return {
                ...state,
                shedConfigs: action.list,
            };
        case 'UPDATE_SHED_CONFIG_LIST':
            {
                const shedConfigs = state.shedConfigs;
                const shedUpdate = shedConfigs.find((o) => o.shedId === action.item.shedId && o.movementTypeId === action.item.movementTypeId);
                if (shedUpdate) shedUpdate.indConfirmCargoInAe = (action.item.indConfirmCargoInAe === 1);

                return {
                    ...state,
                    shedConfigs: [...shedConfigs],
                };
            }
        case 'SET_SHED':
            return {
                ...state,
                shed: action.shed,
                shedObj: action.shedObj
            };
        case 'SET_RACK_TYPE_LIST':
            return {
                ...state,
                rackTypeList: action.list,
            };
        case 'SET_MOVEMENT_TYPE':

            return {
                ...state,
                movementType: action.movementType,
                movementTypeObj: action.movementTypeObj,

            };
        case 'SHOW_SUPPLIER':
        case 'HIDE_SUPPLIER':
            return {
                ...state,
                showSupplierComponent: action.showSupplierComponent
            };
        case 'CLEAR_ALL':
            return {
                ...state,
                mvm: {},
                rackTypeList: [],
                confirmationList: [],
                showSupplierComponent: false
            };
        default:
            return state;
    }
}
